import { render, staticRenderFns } from "./ErstelleKundenbetreuer.vue?vue&type=template&id=5d4ab614&"
import script from "./ErstelleKundenbetreuer.vue?vue&type=script&lang=js&"
export * from "./ErstelleKundenbetreuer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports